module.exports = __webpack_public_path__ + "img/loginLeft.4eb5629c.png";